<app-patient-list [isSlimTable]="false"></app-patient-list>
